import { ICustomerAddress } from './../interfaces/user';

export default class Address {

    static format = (address: ICustomerAddress): string => {
        let s = '';

        s += address.street ? address.street : '';
        s += address.block ? ', ' + address.block : '';
        s += address.city ? ', ' + address.city : '';
        s += address.state ? ', ' + address.state : '';
        s += address.zipcode ? ' ' + address.zipcode : '';

        return s;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/method/Address.ts